import React, { Component } from 'react'
import { Waypoint } from 'react-waypoint';
import { Row, Col } from 'antd'
import numeral from 'numeral'
import { injectIntl, FormattedMessage } from 'react-intl';

import VoronoiChart from '../charts/VoronoiChart/VoronoiChartComponent'
import migrantOrigin_en from '../../assets/data/migrantOrigin_en.json'
import migrantOrigin_fr from '../../assets/data/migrantOrigin_fr.json'
import migrantOrigin_nl from '../../assets/data/migrantOrigin_nl.json'
const migrantOriginFiles = {
  en: migrantOrigin_en,
  nl: migrantOrigin_nl,
  fr: migrantOrigin_fr,
}


const styles = {
  main: {
    //padding: '70vh 2vw',
    display: 'flex',
    fontFamily: 'Open Sans',
    justifyContent: 'space-between',
    position: 'relative',
  },
  btnContainer: {
    position: 'fixed',
  },
  btn: {
    padding: '8px 10px',
    fontSize: '14px',
    margin: '10px',
    fontFamily: 'Open Sans',
  },
  graphic: {
    flexBasis: '100%',
    position: 'sticky',
    width: '100%',
    padding: '30px 0',
    top: '0',
    alignSelf: 'flex-start',
    //backgroundColor: '#aaa',
    //height: '100vh'
  },
  scroller: {
    pointerEvents: 'none',
    zIndex: 100,
    flexBasis: '45%',
    justifyContent: 'flex-end',
  },
  step: {
    fontFamily: 'Open Sans', 
    color: 'black',
    margin: '1rem 2rem 1rem 2rem',
    textShadow: '-1px -1px 0 white, 1px -1px 0 white, -1px 1px 0 white, 1px 1px 0 white',
    paddingTop: 50,
    //paddingBottom: 50,
    width: '70%',
    //border: '1px solid #333',
    pointerEvents: 'none',
  },
  p: {
    fontSize: 35, 
    fontFamily: 'Playfair Display', 
    borderLeftWidth: '5px',
    borderLeftColor: '#e2e2e2',
    borderLeftStyle: 'solid',
    padding: '16px'
  },
  quoted: {
    borderLeftWidth: '5px',
    borderLeftColor: '#e2e2e2',
    borderLeftStyle: 'solid',
    paddingLeft: '16px'
  }
};

class VoronoiMigration extends Component {
  constructor(props) {
    super(props);
    this.state = { width: 0, height: 0, showViz: false };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }
  
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }
  
  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  continentColor = (continent) => {
    var colors = {
      "Europe": "#2196F3",
      "Africa": "#E91E63",
      "Asia": "#FFEB3B",
      "South America": "#F44336",
      "North America": "#D32F2F",
      "Oceania": "#009688",
      "Unknown": "lightgrey"
    };
    return colors[continent];
  }

  showViz = (showViz) => {
    if(showViz !== this.state.showViz)
      this.setState({ showViz });
  }

  render() {
    const { width, showViz } = this.state;

    const { intl } = this.props;
    const { locale } = intl;

    const migrantOrigin = migrantOriginFiles[locale]
    
    const totalCount = migrantOrigin
      .reduce((sum, v) => (sum + v.population), 0)

    const continents = Object.values(migrantOrigin
      .reduce((groupBy, v) => {
        if(! groupBy[v.continent]) groupBy[v.continent] = { name: v.continent, count: 0};
        groupBy[v.continent].count += v.population;
        groupBy[v.continent].proportion = groupBy[v.continent].count / totalCount;
        groupBy[v.continent].continent = v.continent;
        groupBy[v.continent].colorId = v.colorId;
        return groupBy;
      }, {}))
      .sort((a, b) => a.count < b.count ? 1 : -1)
      .filter(d => d.name !== 'Unknown')
      .filter(d => d.name !== 'Inconnu')
      .filter(d => d.name !== 'Onbekend')

    const subContinents = Object.values(migrantOrigin
      .reduce((groupBy, v) => {
        if(! groupBy[v.subContinent]) groupBy[v.subContinent] = { name: v.subContinent, count: 0};
        groupBy[v.subContinent].count += v.population;
        groupBy[v.subContinent].proportion = groupBy[v.subContinent].count / totalCount;
        groupBy[v.subContinent].continent = v.continent;
        groupBy[v.subContinent].colorId = v.colorId;
        return groupBy;
      }, {}))
      .sort((a, b) => a.count < b.count ? 1 : -1)
      .filter(d => d.name !== 'Other')
      .filter(d => d.name !== 'Andere')
      .filter(d => d.name !== 'Autre')
      .filter(d => d.name !== 'Unknown')
      .filter(d => d.name !== 'Inconnu')
      .filter(d => d.name !== 'Onbekend')

    const countries = Object.values(migrantOrigin
      .reduce((groupBy, v) => {
        if(! groupBy[v.country]) groupBy[v.country] = { name: v.country, count: 0};
        groupBy[v.country].count += v.population;
        groupBy[v.country].proportion = groupBy[v.country].count / totalCount;
        groupBy[v.country].continent = v.continent;
        groupBy[v.country].colorId = v.colorId;
        return groupBy;
      }, {}))
      .sort((a, b) => a.count < b.count ? 1 : -1)
      .filter(d => d.name !== 'Other')
      .filter(d => d.name !== 'Andere')
      .filter(d => d.name !== 'Autre')
      .filter(d => d.name !== 'Unknown')
      .filter(d => d.name !== 'Inconnu')
      .filter(d => d.name !== 'Onbekend')

    const maxProportionContinent = Math.max(...continents.map(d => d.proportion))
    const maxProportionSubContinent = Math.max(...subContinents.map(d => d.proportion))
    const maxProportionCountry = Math.max(...countries.map(d => d.proportion))

    return (
      <div>
        <div>
          <div>
            { (width && showViz) && <VoronoiChart height={Math.floor(width*0.27)}/> }
            { !(width && showViz) && <div style={{ height: Math.floor(width*0.27) }} /> }
            <Waypoint
              onEnter={() => this.showViz(true)}
              //onLeave={() => this.showViz(false)}
            />
            <Row>
              <Col offset={2} span={6}>
                <h2><FormattedMessage id="geo.continents"/></h2>
                {continents.map((c, i) => <div 
                  style={{ 
                    color: 'black',
                    borderRadius: 5,
                    paddingLeft: 4,
                    marginBottom: 4,
                    background: `linear-gradient(90deg, ${this.continentColor(c.colorId)} ${Math.round(100 * c.proportion / maxProportionContinent)}%, #f7f5f5 ${Math.round(100 * c.proportion / maxProportionContinent)}%)`,
                  }}
                  key={c.name}>
                    {i+1}. {c.name} {numeral(c.proportion * 100).format(0.0)}% <small>({numeral(c.count).format(0,0)})</small>
                  </div>)
                }
              </Col>
              <Col offset={1} span={6}>
                <h2><FormattedMessage id="geo.subregions"/></h2>
                {subContinents.map((c, i) => <div 
                  style={{ 
                    color: 'black',
                    borderRadius: 5,
                    paddingLeft: 4,
                    marginBottom: 4,
                    background: `linear-gradient(90deg, ${this.continentColor(c.colorId)} ${Math.round(100 * c.proportion / maxProportionSubContinent)}%, #f7f5f5 ${Math.round(100 * c.proportion / maxProportionSubContinent)}%)`,
                  }}
                  key={c.name}>
                  {i+1}. {c.name} {numeral(c.proportion * 100).format(0.0)}% <small>({numeral(c.count).format(0,0)})</small>
                </div>)}
              </Col>
              <Col offset={1} span={6}>
                <h2><FormattedMessage id="geo.countries"/></h2>
                <div style={{ height: 250, overflowY: 'scroll' }}>
                  {countries.map((c, i) => <div 
                    style={{ 
                      color: 'black',
                      borderRadius: 5,
                      paddingLeft: 4,
                      marginBottom: 4,
                      background: `linear-gradient(90deg, ${this.continentColor(c.colorId)} ${Math.round(100 * c.proportion / maxProportionCountry)}%, #f7f5f5 ${Math.round(100 * c.proportion / maxProportionCountry)}%)`,
                    }}
                    key={c.name}>
                    {i+1}. {c.name} {numeral(c.proportion * 100).format(0.0)}% <small>({numeral(c.count).format(0,0)})</small>
                  </div>)}
                </div>
              </Col>
            </Row>
            <div style={styles.step }>
              <div style={styles.p}>
                <FormattedMessage id="geo.title4"/> 
              </div>
              <h4 style={{ ...styles.quoted, paddingBottom: 16 }}>
                <FormattedMessage id="geo.text"/>
              </h4>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(VoronoiMigration)